export default "__VITE_ASSET__BqzPEG8I__"